import React, { FC } from "react";
import Grid from "@material-ui/core/Grid/Grid";
import uniqueId from "lodash/fp/uniqueId";
import Typography from "@material-ui/core/Typography/Typography";
import { useStyles } from "./styles";
import { Seller } from "src/providers/AnalyticsStore/types";

const SellerFieldList: FC<{ data: Seller }> = ({ data }) => {
  const { rowFields, zeroPad, subTotal } = useStyles();

  return (
    <Grid container direction="row" alignItems="center" spacing={2} className={rowFields}>
      <Grid item xs key={uniqueId("report")} className={zeroPad}>
        <Typography variant="body2">{data.sellerName}</Typography>
      </Grid>
      <Grid item xs key={uniqueId("report")} className={subTotal}>
        <Typography variant="body2" style={{ fontWeight: 600 }}>
          {data.subtotalWithoutVat.toLocaleString(navigator.language, {
            minimumFractionDigits: 2,
          }) || " --- "}
          kr
        </Typography>
      </Grid>
    </Grid>
  );
};
export default SellerFieldList;
